import React from "react";

import video from '../../video/video4.mov'
import FullUniqueLogo from "../../img/FullLogoDiscotechAlyonsWhite.png";

export const NotFoundPage = () => {
  return (
    <section
      id="main"
      className="w-full flex flex-col justify-center items-center"
    >
      <div className="w-full flex flex-col items-center justify-center">
        <div className="w-full h-screen relative bg-black">
          <video
            className="absolute top-0 left-0 w-full h-full object-cover blur-3xl"
            src={video}
            autoPlay
            loop
            muted
            playsInline
          />
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 flex flex-col space-y-16 items-center justify-center font-lack m-0 p-0">
          <a 
          href="https://t.me/discotg/66"
          target="_blank"
          rel="noreferrer"
          >
          <img
        src={FullUniqueLogo}
        alt="bg"
        className="w-64 h-16 object-contain"
      />
      </a>
            <p className="text-[35px] lg:text-[45px] xl:text-[50px] text-center text-white leading-[50px] whitespace-pre-line">{`страница не найдена`}</p>
            <button className="px-4 py-2 bg-white text-black font-lack rounded-xl bg-opacity-70 text-lg"
            onClick={() => window.location.href = "/"}>
              вернуться на главную
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};
